import { call, put, takeLatest, all } from 'redux-saga/effects';
import config from 'config';
import apiClient from '../helpers/apiClient';
import * as actionTypes from '../actionTypes/hto';

let _client = null;

function* getHTOSlots({ pincode }) {
    const successAction = { type: actionTypes.HTO_SLOTS_SUCCESS };
    const errorAction = { type: actionTypes.HTO_SLOTS_FAIL };
    try {
        const response = yield call(async () => _client.get(`${config.apiPath.homeEyeCheckup}?pinCode=${pincode}`));
        successAction.data = response && response.result;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runHTOCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.GET_HTO_SLOTS, getHTOSlots)
    ]);
}
